import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    RegionZeroLevel, ServiceProcess, ServiceCenterStatus, ServiceCenterType, OperationalDays,
} from 'app/enums/label.enums'

import {
    ServiceCentersTableType,
} from './serviceCenters.types'

const config: SkyNetTableConfig<keyof ServiceCentersTableType> = {
    name: 'ServiceCenter',
    tabs: [{
        name: 'All',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'serviceCenterNumber',
                labelKey: 'ServiceCenters.serviceCenterNumber',
                reduced: true,
            },
            {
                name: 'locationLocationName',
                filterField: 'locationLocationName',
                filterType: FilterType.Array,
                labelKey: 'ServiceCenters.location',
                reduced: true,
            },
            {
                name: 'serviceCenterStatus',
                filterField: 'serviceCenterStatus',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: ServiceCenterStatus,
                labelKey: 'ServiceCenters.serviceCenterStatus',
            },
            {
                name: 'serviceCenterType',
                filterField: 'serviceCenterType',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: ServiceCenterType,
                labelKey: 'ServiceCenters.serviceCenterType',
            },
            {
                name: 'operationalDays',
                filterField: 'operationalDays',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: OperationalDays,
                labelKey: 'ServiceCenters.operationalDays',
            },
            {
                name: 'orderSelectionDelay',
                labelKey: 'ServiceCenters.orderSelectionDelay',
            },
            {
                name: 'enabledProcesses',
                componentName: 'EnumList',
                allowedValuesEnum: ServiceProcess,
                labelKey: 'ServiceCenters.enabledProcesses',
            },
            {
                name: 'regionZeroLevel',
                filterField: 'regionZeroLevel',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: RegionZeroLevel,
                labelKey: 'Country.regionZeroLevel',
            },
        ],
    }],
}

export default config
